export const coreColors = {
    blue100: '#0000ff',
    blue200: '#617996',
    blue300: '#4a87c4',
    blue400: '#30ACFF',
    grey100: '#efefef',
    grey200: '#bbbbbb',
    grey300: '#AEAEAE',
    grey400: '#4b545f'

}

export const sectionHeaderStyle = {
    fontSize: '32px',
    color: coreColors.blue300,
    weight: 700,
    marginTop: 10,
    marginBottom:25,
    textAlign: 'left'

}

export const subSectionHeaderStyle= {
    fontSize: '18px',
    color: coreColors.blue300,
    weight: 500,
    marginTop: 15,
    marginBottom: 15,
    textAlign: 'left'

}

export const disclaimerTextStyle= {
    fontSize: 12,
    color: coreColors.blue400,
    weight: 600,
    textAlign: 'center',
    margin: 10
}

export const sectionTextStyle= {
    textAlign: 'left',
    marginLeft: 45,
    fontSize: 14
}



// WEBPACK FOOTER //
// ./src/styles/shared/variables.js